<template>
    <div>
        <Header>

            <div class="filter-box filter-box--full-padded">
                <div class="filter-box__left">
                    <div class="search-box">
                        <input type="text" v-model="search_term" placeholder="Filter Media..." class="v-pristine v-untouched v-valid v-empty">
                    </div>
                    <div class="filter-box__right">
                        <a :class="{'active': mode=='list'}" @click="setMode('list')"><i class="material-icons">view_list</i></a>
                        <a :class="{'active': mode=='grid'}" @click="setMode('grid')"><i class="material-icons">view_comfy</i></a>
                    </div>
                </div>
            </div>
        </Header>

        <div class="page">

            <div class="grid-12 grid--articles" v-if="mode=='grid'">

                <div class="loading-gif" v-if="!images">
                    <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                </div>


                <div v-if="images&&images.length == 0" style="padding: 30px;" v-t="'You haven\'t uploaded any images yet'">

                </div>

                <div class="grid-item-3" v-bind:key="image.id" v-for="image in images">
                    <a class="block--card" @click="$parent.editImage(image, deleteCallback, updateCallback)">
                        <div class="card__img" :style="{'background-image': 'url('+image.small+')'}"></div>
                        <div class="card__content">
                            <p class="meta">{{image.image_width}}px x {{image.image_height}}px<br> Uploaded {{image.created | date}} </p>
                            <p class="name" :title="image.name">{{image.name}}</p>
                        </div>
                    </a>
                </div>
            </div>


            <table class="editor-table editor-table--articles" v-if="mode=='list'">
                <tbody v-if="!images">
                    <tr>
                        <td colspan="100%">
                            <div class="loading-gif" >
                                <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="images">
                    <tr v-bind:key="image.id" v-for="image in images" >
                        <td @click="$parent.editImage(image, deleteCallback, updateCallback)">
                            <a class="img" :style="{'background-image': 'url('+image.small+')'}"></a>
                            <div class="img-text">
                                <a>{{image.name}}</a>
                                <a v-if="!image.name">-</a>
                                <span class="ellipsis grey">
                                    Uploaded {{image.created | date}} &bullet; {{image.image_width}}px x {{image.image_height}}px
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="images">
                    <td colspan="100%" >
                        {{images.length}} <span v-t="'Images'"></span>

                    </td>
                </tfoot>
            </table>
        </div>

    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header,
        },
        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                search_term: '',
                mode: 'grid',
                images: null,
                loading: false
            }
        },
        methods: {
            deleteCallback (image_id){
                var idx = null
                var found = false
                for (var i=0; i<this.images.length; i++){
                    var img = this.images[i]
                    if (img.id === image_id){
                        idx = i
                        found = true
                    }
                }
                if (found){
                    this.images.splice(idx, 1)
                }
            },
            updateCallback (image){
                for(var i=0; i<this.images.length; i++){
                  if(this.images[i].id === image.id){
                    this.images[i] = image
                    this.$forceUpdate();
                  }
                }
            },
            setMode (mode) {
                this.mode = mode
                if (typeof window.localStorage !== 'undefined') {
                    window.localStorage.setItem("articles_filter_mode", mode);
                }
            },
            updateContent (start_at) {
                var items = [];
                if(this.search_term && this.search_term !== ''){
                    items.push('search='+this.search_term);
                }
                if(start_at !== 0){
                    items.push('page='+Math.ceil(Number(start_at/25)).toFixed(0));
                }

                this.$http.get('/images/?pagesize=25&'+items.join('&')).then(data => {
                    if(start_at === 0){
                        this.images = data.data
                    }else{
                        this.loading = false
                        this.images = this.images.concat(data.data)
                    }
                })
            },
            handleScroll () {
                var documentHeight = Math.max( document.body.scrollHeight, document.body.offsetHeight,
                   document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight );

                if((window.scrollY + window.innerHeight) > documentHeight - 400){
                    if(!this.loading && this.images){
                        this.loading = true
                        this.updateContent(this.images.length)
                    }
                }
            },
        },
        watch: {
            search_term () {
                this.updateContent(0);
            }
        },
        beforeDestroy () {
            document.removeEventListener('scroll', this.handleScroll);
        },
        mounted () {
            this.$http.get('/images/?pagesize=25').then(data => {
                this.images = data.data
                document.addEventListener('scroll', this.handleScroll);
            })

            if (typeof window.localStorage !== 'undefined') {
                var mode = window.localStorage.getItem('media_filter_mode');
                if(mode !== null){
                    this.mode = mode
                }else{
                    this.mode = 'grid'
                }
            }else{
                this.mode = 'grid'
            }

        }
    }
</script>
